import { createAction } from "redux-act";

// Detail
export const MEMConsentVSDetail = createAction("MEM_CONSENTVS_DETAIL");